import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Tab } from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { findMatchingPath } from "../../utils/helper";
import { HEADER_TITLE_DEFAULT } from "../../data/StaticData";
import FundItem from "./FundItem";
import StockItem from "./StockItem";
import AllItemOverview from "./AllItemOverview";
import AllBrandsOverview from "./AllBrandsOverview";
import AllSubCategoryOverview from "./AllSubCategoryOverview";
import { tabNodes, visibleTabs, firstVisibleTab, isTabVisible } from "../../utils/menuNodes";

const TABS = [
  { component: AllItemOverview, eventKey: "0" },
  { component: FundItem, eventKey: "1" },
  { component: StockItem, eventKey: "2" },
  { component: AllBrandsOverview, eventKey: "3" },
  { component: AllSubCategoryOverview, eventKey: "4" },
];

const ItemMaster = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userPermission } = useSelector(selectUser);
  const [matchingPathObject, setMatchingPathObject] = useState(null);
  const activeTab = searchParams.get("tab") || "0";

  useEffect(() => {
    if (userPermission) {
      const result = findMatchingPath(userPermission, pathname);
      setMatchingPathObject(result);
      // Land on the first tab this role may see; a ?tab= that points at a
      // hidden one is redirected the same way.
      if (!searchParams.get("tab") || !isTabVisible(result, searchParams.get("tab"))) {
        navigate(`?tab=${firstVisibleTab(result)}`, { replace: true });
      }
    }
  }, [userPermission, pathname, searchParams, navigate]);

  const checkPermission = tabNodes(matchingPathObject)[activeTab];

  return (
    <>
      <Helmet>
        <title>MasterData Management · {HEADER_TITLE_DEFAULT}</title>
      </Helmet>
      <Col md={12} data-aos={"fade-up"}>
        <Card className="card-bg p-2">
          <Tab.Container id="tabs" activeKey={activeTab}>
            <Nav
              className="nav-pills flex-nowrap overflow-auto"
              style={{ whiteSpace: "nowrap" }}
              variant="pills"
            >
              {visibleTabs(matchingPathObject).map(({ node: module, index }) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    as={Link}
                    to={`?tab=${index}`}
                    eventKey={`${index}`}
                  >
                    {module.title}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>

            <Tab.Content>
              {TABS?.map(({ component: Component, eventKey }) => (
                <Tab.Pane className="mt-3" key={eventKey} eventKey={eventKey}>
                  {eventKey == activeTab ? (
                    <Component checkPermission={checkPermission} />
                  ) : (
                    ""
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </Card>
      </Col>
    </>
  );
};

export default ItemMaster;
